import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Zap, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Failed to send reset link");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-900 mb-6" data-testid="forgot-back-login">
          <ArrowLeft className="w-4 h-4"/> Back to login
        </Link>
        <div className="bg-white border border-zinc-200 rounded-xl p-8 card-crisp">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-9 h-9 rounded-md bg-[#FF5A00] flex items-center justify-center"><Zap className="w-5 h-5 text-white" strokeWidth={2.5}/></div>
            <div className="font-heading font-bold text-xl">LeadForge</div>
          </div>
          {sent ? (
            <div className="text-center py-6" data-testid="forgot-sent">
              <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3"/>
              <h1 className="font-heading text-2xl font-bold mb-2">Check your email</h1>
              <p className="text-zinc-600 text-sm">If <span className="font-mono-accent">{email}</span> matches an account, we've sent a password reset link.</p>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-bold mb-2">Reset your password</h1>
              <p className="text-zinc-500 text-sm mb-6">Enter your email and we'll send a reset link.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label>Email</Label>
                  <Input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="forgot-email-input"/>
                </div>
                {err && <div className="text-sm text-rose-600" data-testid="forgot-error">{err}</div>}
                <Button type="submit" disabled={busy} className="w-full bg-[#FF5A00] hover:bg-[#E04F00] text-white btn-lift" data-testid="forgot-submit-btn">
                  {busy ? "Sending…" : "Send reset link"}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
